import React from 'react';

import styled from 'styled-components';

type ValidationItem = {
  name?: string;
  description?: string;
};

type Props = {
  title: string;
  items: ValidationItem[];
  iconSrc: string;
  iconBackgroundColor: string;
  itemBackgroundColor?: string;
  note: string;
  sectionTestId: string;
};

const List = styled.div`
  padding: 0;
  margin-top: 5px;
  gap: 5px;
`;

const Item = styled.div<{ backgroundColor: string }>`
  padding: 10px;
  display: flex;
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 4px;
  margin-top: 5px;
`;

const ItemIcon = styled.div<{ backgroundColor: string }>`
  width: 26px;
  height: 26px;
  flex: 0 0 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 4px;
  margin-right: 10px;
`;

const ItemInfo = styled.div`
  font-size: 12px;
`;

const ItemName = styled.div`
  font-size: 14px;
  font-family: var(--font-bold);
`;

const ItemDescription = styled.div`
  white-space: pre-line;
`;

const ShopRequestValidationSection = ({
  title,
  items,
  iconSrc,
  iconBackgroundColor,
  itemBackgroundColor = 'var(--lighter-gray)',
  note,
  sectionTestId,
}: Props) => {
  if (!items.length) return null;

  return (
    <div data-test-id={`${sectionTestId}-section`}>
      <strong data-test-id={`${sectionTestId}-title`}>{title}</strong>
      <List data-test-id={`${sectionTestId}-list`}>
        {items.map((item, index) => (
          <Item
            key={`${item?.name || title}-${index}`}
            backgroundColor={itemBackgroundColor}
            data-test-id={`${sectionTestId}-item-${index}`}
          >
            <ItemIcon backgroundColor={iconBackgroundColor} data-test-id={`${sectionTestId}-item-${index}-icon`}>
              <img
                src={iconSrc}
                data-test-id={`${sectionTestId}-item-${index}-icon-image`}
                style={{
                  width: 16,
                  height: 16,
                }}
              />
            </ItemIcon>
            <ItemInfo data-test-id={`${sectionTestId}-item-${index}-info`}>
              <ItemName data-test-id={`${sectionTestId}-item-${index}-name`}>{item?.name}</ItemName>
              <ItemDescription data-test-id={`${sectionTestId}-item-${index}-description`}>
                {item.description?.replace(/\\n/g, '\n')}
              </ItemDescription>
              <div data-test-id={`${sectionTestId}-item-${index}-note`}>{note}</div>
            </ItemInfo>
          </Item>
        ))}
      </List>
    </div>
  );
};

export default ShopRequestValidationSection;
